import {
  Box,
  Button,
  FormControl,
  Grid,
  makeStyles,
  Paper,
  Select,
  Typography,
} from "@material-ui/core";
import { Add } from "@material-ui/icons";
import { Skeleton } from "@material-ui/lab";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { backend } from "../../../../api";
import AddBook from "./Modals/AddBook";
import { MdFilterList } from "react-icons/md";
import BookList from "./BookList";
import { Pagination } from "@mui/material"; // Import Pagination

const useStyles = makeStyles((theme) => ({
  root: {
    border: `1px solid ${theme.palette.secondary.dark}`,
    borderRadius: "5px",
    marginTop: "30px",
    padding: "10px",
    [theme.breakpoints.down("md")]: {
      marginTop: "30px",
    },
  },
  tabHeading: {
    fontSize: "32px",
    fontWeight: 550,
    margin: "0",
  },
  userName: {
    color: theme.palette.primary.dark,
    fontSize: 22,
    fontWeight: 500,
  },
  subHead: {
    margin: 0,
    fontSize: 18,
    fontWeight: 550,
    width: "170px",
  },
  contactBox: {
    display: "flex",
    flexWrap: "wrap",
    padding: "8px 0",
    margin: "0px",
    borderBottom: `1px solid ${theme.palette.secondary.dark}`,
  },
}));

function Products(props) {
  const classes = useStyles();
  const { user } = props;
  const history = useHistory();

  const [books, setBooks] = useState([]);
  const [bookList, setBookList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const booksPerPage = 8; // Number of books per page

  useEffect(() => {
    fetchAuthorBooks();
  }, []);

  const fetchAuthorBooks = () => {
    setLoading(true);

    backend
      .get(`/book?author=${user?.author?._id}`)
      .then((res) => {
        setBooks(res.data.data);
        setBookList(
          res.data.data.filter(
            (book) => book.isActive === true && book.isPublished === true
          )
        );
      })
      .catch((err) => {
        toast.error(err.response ? err.response.data.message : err.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const publishingChoice = () => {
    history.push("/author/add");
  };

  const handleFilterProducts = (e) => {
    if (e.target.value === "approved") {
      setBookList(
        books.filter(
          (book) => book.isActive === true && book.isPublished === true
        )
      );
    } else if (e.target.value === "requested") {
      setBookList(books.filter((book) => book.isPublished === false));
    } else if (e.target.value === "inactive") {
      setBookList(books.filter((book) => book.isActive === false));
    } else {
      setBookList(books);
    }
    setCurrentPage(1); // Reset to first page when filtering
  };

  // Get current books
  const indexOfLastBook = currentPage * booksPerPage;
  const indexOfFirstBook = indexOfLastBook - booksPerPage;
  const currentBooks = bookList.slice(indexOfFirstBook, indexOfLastBook);

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  return (
    <div className={classes.root}>
      <h2 className={classes.tabHeading}>My Products</h2>

      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={4}
      >
        <Button
          variant="outlined"
          startIcon={<Add />}
          onClick={publishingChoice}
        >
          Add Book
        </Button>
        <FormControl
          variant="outlined"
          className={classes.filterSelect}
          startIcon={<MdFilterList />}
        >
          <Select native onChange={handleFilterProducts}>
            <option value="approved">Active</option>
            <option value="inactive">Inactive</option>
            <option value="requested">Unapproved</option>
          </Select>
        </FormControl>
      </Box>
      {currentBooks && currentBooks.length > 0 ? (
        <>
          <BookList books={currentBooks} />
          {bookList.length > booksPerPage && (
            <Box display="flex" justifyContent="center" mt={4}>
              <Pagination
                count={Math.ceil(bookList.length / booksPerPage)}
                page={currentPage}
                onChange={handlePageChange}
                sx={{
                  "& .MuiPaginationItem-root": {
                    "&:hover": {
                      backgroundColor: "#FECE00",
                    },
                  },
                  "& .Mui-selected": {
                    backgroundColor: "#FECE00",
                    color: "#000",
                  },
                  "& .MuiPaginationItem-ellipsis": {
                    color: "#FECE00",
                  },
                }}
              />
            </Box>
          )}
        </>
      ) : loading ? (
        <Box>
          <Grid container spacing={2}>
            {[...Array(3)].map((_, index) => (
              <Grid item xs={12} md={4} lg={3} key={index}>
                <Paper elevation={2} className={classes.paper}>
                  <Skeleton
                    variant="rect"
                    width={200}
                    height={300}
                    animation="wave"
                    style={{ margin: "0 auto" }}
                  />
                  <Skeleton animation="wave" />
                  <Skeleton animation="wave" />
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Box>
      ) : (
        <Box>
          <Typography
            variant="h2"
            color="error"
            style={{ margin: "30px auto" }}
          >
            No Books created yet.
          </Typography>
        </Box>
      )}
    </div>
  );
}

export default Products;
